export const LINE_HEIGHT_RATIO = 1.32;
export const COLOR_ERROR = 'rgb(255, 56, 56)';
export const SMILEY_SCALE_VALUES = ['Awful', 'Poor', 'Ok', 'Good', 'Awesome'];
